import React, { useState } from "react";
import "../../styles/desktop/plus.css";
import bot from "../../assets/img/robot-black.png";

const Plus = () => {
    let user = sessionStorage.getItem("user");
    user = user ? JSON.parse(user).name : "visitante";

    // Array de mensagens para exibição
    const messages = [
        `Olá, ${user}! \nMeu nome é CAC, sou seu assistente virtual personalizado!`,
        "Você deve estar em dúvida sobre o que eu faço, certo?",
        "No menu lateral esquerdo estão as opções de serviços que ofereço.",
        "Na aba Dispositivos, você verá o estado atual dos dispositivos rastreados em seu condomínio.",
        "Caso algum dispositivo perca conexão com a rede local um evento será gerado.",
        "Você poderá visualizar os eventos gerados aba Registros e direcionar uma notificação a um ou mais responsáveis do condominio.",
        "Na opção Chatbot, você poderá conversar comigo e tirar suas dúvidas sobre o condominio.",
        "Agora na aba Gestão, você poderá realizar a troca de senha e alterar os dados de seu usuário, também, vizualizar nosso contrato de prestação de serviços e finalizar sua sessão.",
        "Se tiver com dúvidas sobre os recursos, entre em contato com o time de suporte.",
    ];

    const messagesAdmin = [
        `Olá, ${user}! \nMeu nome é CAC, sou seu assistente virtual personalizado!`,
        "Você deve estar em dúvida sobre o que eu faço, certo?",
        "No menu lateral esquerdo estão as opções de serviços que ofereço.",
        "Na aba Dispositivos, você verá o estado atual dos dispositivos rastreados em seu condomínio.",
        "Caso algum dispositivo perca conexão com a rede local um evento será gerado.",
        "Você poderá visualizar os eventos gerados aba Registros e direcionar uma notificação a um ou mais responsáveis do condominio.",
        "Na opção Chatbot, você poderá conversar comigo e tirar suas dúvidas sobre o condominio.",
        "Agora na aba Gestão, você poderá realizar a troca de senha e alterar os dados de seu usuário, também, vizualizar nosso contrato de prestação de serviços e finalizar sua sessão.",
        "Se tiver com dúvidas sobre os recursos, entre em contato com o time de suporte.",
    ];

    // Estado para controlar o índice da mensagem atual
    const [messageIndex, setMessageIndex] = useState(0);

    // Função para alternar a mensagem ao clicar no botão
    const changeMessage = () => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    };

    return (
        <div className="tela-container"> 
        <div className="containerPlus">
            <div className="botContainer">
                <div className="botCircle">
                    <img src={bot} alt="bot" className="bot" />
                </div>
            </div>
            <div className="modalMensagem">   
                <div className="mensagemChat">
                    <p>
                        {messages[messageIndex].split('\n').map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                        ))}
                    </p>
                </div>
                {messageIndex < messages.length - 1 && (
                    <button onClick={changeMessage} className="changeMessageButton">
                        continuar
                    </button>
                )}


                {messageIndex === messages.length - 1 && (
                    <a href="mailto:chatbot.comando@gmail.com" className="plusButton">
                        Contatar suporte
                    </a>
                )}
            </div>
        </div>
        </div>
    );
};

export default Plus;
